import React from 'react';

import { useMemo, useState } from 'react'
import { connect, useSelector } from 'react-redux'

import DataTable from '../../containers/DataTable'

import pathAPICall from '../../app/apiCalls/pathAPICall'
import { paths_list } from '../../app/apiEndpoints'
import { tableTypes } from '../../app/settings';
import ActiveTableToggle from '../../containers/ActiveTableToggle';

import { selectPath } from '../../app/store/actions/pathActions'

const PathsTable = ({cascadeType, title, description, showDetailsOnClick, selectPath}) => {
    const [data, setData] = useState([])
    const [displayView, setDisplayView] = useState(1)

    const tableID = "path"
    const tableFields = ["ID", "Name", "Type", "Niche", "Active", "Use in Cascade?"]

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const rowID = useSelector((state) => state.currentPathID)
    //const isSysadmin = useSelector((state) => state.user.isSysadmin)

    useMemo(() => {
        const getData = async () => {
            const data = await pathAPICall(paths_list, {'requester': userID, 'company': companyID, 'cascadeType': cascadeType })
            setData(data.paths)
        }
        getData()
    }, [userID, companyID, cascadeType])

    const onClick = (e) => {
        if(!showDetailsOnClick) return;
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")
        selectPath(rowID)
    }

    const tableData = () => {
        if(data.length === 0) {
            return [];
        } 
        let rows = [];
        data.forEach(row => {
            if(displayView === 1 && row.is_active === "0") { return }
            rows.push({'id': row.pathid, 'values': [
                row.pathid,
                row.path,
                row.type === '2' ? 'Affiliate' : (row.type === '3' ? 'Fallback' : 'CPC'),
                row.niche ?? '',
                row.is_active === '1' ? 'Yes' : 'No',
                row.useInAutoFlow === '1' ? 'Yes' : 'No'
                //`${isSysadmin ? `<a href="/landers/${row.lpid}/" class="btn btn-primary btn-sm">Data</a>` : ''}`
            ]});
        });
        return rows
    }

    const filterData = (e) => {
        let { value } = e.target;
        setDisplayView(parseInt(value))
    }

    return (
        <>
            <ActiveTableToggle title={title} description={description} value={displayView} onChange={filterData} />
            <DataTable hover={true} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} tableSettings={tableTypes.None} onClick={onClick} currentRowID={rowID} />
        </>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        selectPath: (id) => { 
            dispatch(selectPath(id))
        }
    }
  }

export default connect(state => ({...state}),mapDispatchToProps)(PathsTable)